module.exports = __webpack_public_path__ + "static/media/air_conditioner.66d6a0fd.png";